import { PaymentState, PaymentActionTypes, PaymentAction } from './paymentTypes'

const initialState: PaymentState = {
  payment: [],
  isLoading: true,
}

export default function paymentReducer(
  state = initialState,
  action: PaymentAction
) {
  switch (action.type) {
    // get item
    case PaymentActionTypes.GET_PAYMENT_START:
      return {
        ...state,
        isLoading: true,
      }

    case PaymentActionTypes.GET_PAYMENT_SUCCESS:
      if (!action.payment) {
        throw new Error()
      }
      return {
        ...state,
        isLoading: false,
        payment: action.payment,
      }

    case PaymentActionTypes.GET_PAYMENT_ERROR:
      return {
        ...state,
        isLoading: false,
      }

    default:
      return state
  }
}
